import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useEffect, useState } from "react";
import Record from "../record";
import OpdReports from "../inPatientDetail/OpdReports";
import PathLab from "../path-lab";
import { useAuth } from "../../context/AuthContext";
import Appointments from "../appointments";
import { useSubscriptionCapabilities } from "../../hooks/useSubscriptionCapabilities";
import { isPathModuleStaffRole } from "../../utils/pathRoleUtils";

const Index = ({ appointment, onClose, patient = null }) => {
  const { user } = useAuth();
  const { hasPathPackageAccess, loading: subscriptionLoading } =
    useSubscriptionCapabilities();
  const isPathStaff = isPathModuleStaffRole(user?.roleName);
  // Path staff default to Pathology Data. Do not wait on hasPathPackageAccess here —
  // subscription starts false on mount and would incorrectly land them on Add New Record.
  const [selectedTab, setSelectedTab] = useState(
    isPathStaff ? "3" : user?.roleName === "frontdesk" ? "4" : "1"
  );

  useEffect(() => {
    if (subscriptionLoading) return;

    // Path staff must land on Pathology Data once package access is known
    if (isPathStaff && hasPathPackageAccess) {
      setSelectedTab("3");
      return;
    }

    // Leave Pathology tab if Basic package (no path module).
    // Path staff stay off doctor "Add New Record" when path package is unavailable.
    if (!hasPathPackageAccess && selectedTab === "3" && !isPathStaff) {
      setSelectedTab(user?.roleName === "frontdesk" ? "4" : "1");
    }
  }, [
    hasPathPackageAccess,
    subscriptionLoading,
    selectedTab,
    user?.roleName,
    isPathStaff,
  ]);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <TabContext value={selectedTab}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList
          textColor="secondary"
          indicatorColor="secondary"
          onChange={handleChange}
        >
          <Tab className="other-non-printable"
            label="Add New Record"
            value="1"
            disabled={isPathStaff || user?.roleName === "frontdesk"}
          />
          <Tab className="other-non-printable"
            label="Patient History"
            value="2"
            disabled={isPathStaff}
          />
          {hasPathPackageAccess && (
            <Tab className="other-non-printable"
              label="Pathology Data"
              value="3"
              disabled={user?.roleName === "frontdesk"}
            />
          )}
          {user?.roleName === "frontdesk" && (
            <Tab label="Appointment Data" value="4" />
          )}
        </TabList>
      </Box>
      {!isPathStaff && (
        <TabPanel value="1">
          <Record appointment={appointment} onClose={onClose} />
        </TabPanel>
      )}
      {!isPathStaff && (
        <TabPanel value="2">
          <OpdReports
            patientId={appointment?.patientId}
            showHeader={false}
            initialPatientInfo={patient}
          />
        </TabPanel>
      )}
      {hasPathPackageAccess && (
        <TabPanel value="3">
          <PathLab appointment={appointment} patient={patient} />
        </TabPanel>
      )}
      {user?.roleName === "frontdesk" && (
        <TabPanel value="4">
          <Appointments patient={appointment} />
        </TabPanel>
      )}
    </TabContext>
  );
};

export default Index;
